import { render } from "./mollie.vue?vue&type=template&id=9412c350"
import script from "./mollie.vue?vue&type=script&lang=js"
export * from "./mollie.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__